module.exports = __webpack_public_path__ + "img/logo-site-ai2p.5973774f.png";